import React, { useState } from "react";
import TableView from "../components/TableView";
import BookingForm from "../components/BookingForm";
import CalendarView from "../components/CalendarView";  
import MainLayoutWithoutFooter from '../components/MainLayoutWithoutFooter';
import "../styles/reservationTabs.css";
import BookingsReportMenu from "../components/BookingsReportMenu";

const Reservation = () => {
  const [activeTab, setActiveTab] = useState("calendarView");
  const [focusDate, setFocusDate] = useState(null);
  // Set by the calendar's per-day add button so the Create New form opens on that date. Cleared when
  // the tab is opened directly, otherwise a date picked earlier would silently seed a later visit.
  const [newBookingDate, setNewBookingDate] = useState(null);

  return (
    <MainLayoutWithoutFooter>
    <div className="pageContent reservationsPage pb-2">
      <div className="container">
        <h2 className="lgTitle mb-3">Reservations</h2>
        <div className="tabStyle" id="seatingTab" role="tablist">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
            <div className="swiper reservationsSwiper">
              <div className="swiper-wrapper">
                <div className="swiper-slide w-auto">
                  <button
                    className={`nav-link ${activeTab === "calendarView" ? "active" : ""}`}
                    id="cView"
                    type="button"
                    role="tab"
                    aria-controls="calendarView"
                    aria-selected={activeTab === "calendarView"}
                    onClick={() => setActiveTab("calendarView")}
                  >
                    <svg width="40" height="40" className="tabNavIcon">
                      <use xlinkHref="./images/sprite.svg#iconCalendar"></use>
                    </svg>
                    Calendar View
                  </button>
                </div>
                <div className="swiper-slide w-auto">
                  <button
                    className={`nav-link ${activeTab === "tableView" ? "active" : ""}`}
                    id="tView"
                    type="button"
                    role="tab"
                    aria-controls="tableView"
                    aria-selected={activeTab === "tableView"}
                    onClick={() => setActiveTab("tableView")}
                  >
                    <svg width="40" height="40" className="tabNavIcon">
                      <use xlinkHref="./images/sprite.svg#iconTable"></use>
                    </svg>
                    Table View
                  </button>
                </div>
                <div className="swiper-slide w-auto">
                  <button
                    className={`nav-link ${activeTab === "createNew" ? "active" : ""}`}
                    id="cNew"
                    type="button"
                    role="tab"
                    aria-controls="createNew"
                    aria-selected={activeTab === "createNew"}
                    onClick={() => { setNewBookingDate(null); setActiveTab("createNew"); }}
                  >
                    <svg width="40" height="40" className="tabNavIcon">
                      <use xlinkHref="./images/sprite.svg#iconCreateNew"></use>
                    </svg>
                    Create New
                  </button>
                </div>
              </div>
            </div>

            <BookingsReportMenu />
          </div>

          <div className="tab-content" id="seatingTabContent">
            {activeTab === "calendarView" && (
              <div
                className="tab-pane fade show active"
                id="calendarView"
                role="tabpanel"
                aria-labelledby="cView"
                tabIndex={0}
              >
                <CalendarView
                  focusDate={focusDate}
                  onAddBooking={(date) => {
                    setNewBookingDate(date);
                    setActiveTab("createNew");
                  }}
                />
              </div>
            )}
            {activeTab === "tableView" && (
              <div
                className="tab-pane fade show active"
                id="tableView"
                role="tabpanel"
                aria-labelledby="tView"
                tabIndex={0}
              >
                <TableView />
              </div>
            )}
            {activeTab === "createNew" && (
              <div
                className="tab-pane fade show active"
                id="createNew"
                role="tabpanel"
                aria-labelledby="cNew"
                tabIndex={0}
              >
                <BookingForm
                  key={newBookingDate || "blank"}
                  initialDate={newBookingDate}
                  onBookingSuccess={(date) => {
                    setNewBookingDate(null);
                    setFocusDate(date);
                    setActiveTab("calendarView");
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    </MainLayoutWithoutFooter>
  );
};

export default Reservation;
